import React, { useEffect, useState } from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import SwapCallsOutlinedIcon from "@material-ui/icons/SwapCallsOutlined";

import LiveHelpOutlinedIcon from "@material-ui/icons/LiveHelpOutlined";
import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import ReactTable from "components/Tables/ReactTable.js";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import TableHeader from "components/Tables/TableHeader";
import { useHistory, useParams } from "react-router-dom";
import AlertModal from "components/Alerts/AlertModal";
import { definePathwayStore } from "store";
import { GetAllPathwaysUrl } from "axios/adminAPIsUrls";
import useAxios from "axios/httpService";
import { GetInquiryTypeUrl } from "axios/adminAPIsUrls";
import { NotificationManager } from "components/common/ReactNotifications";
import { apiErrorHandler } from "helpers/apiErrorHandler";
import { DeletePathwayUrl } from "axios/adminAPIsUrls";
import Loading from "components/Loading/Loading";
import authStore from "store/authStore";
import jwtDecode from "jwt-decode";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
  mtZero: {
    marginTop: "0px",
  },
  ptZero: {
    paddingTop: "0px !important",
  },
};

const useStyles = makeStyles(styles);

const definePathways = () => {
  const history = useHistory();
  const userToken = authStore((state) => state.userToken);
  let { inquiryParamId } = useParams();

  const pageSize = 8;
  const [currentPage, setCurrentPage] = useState(1);
  const [pathwayId, setPathwayId] = useState("");
  const [alert, setAlert] = useState(false);
  const [data, setData] = useState([]);
  const token = localStorage.getItem("token");

  const [
    { data: pathwaysData, error, loading },
    ExecuteGetAllPathwaysUrl,
  ] = useAxios(
    GetAllPathwaysUrl(inquiryParamId, pageSize, currentPage, token),
    { manual: true }
  );

  const [
    { loading: deleteLoading },
    ExecuteDeletePathway,
  ] = useAxios(DeletePathwayUrl(pathwayId, token), { manual: true });

  const deletePathwayhandler = async () => {
    try {
      const res = await ExecuteDeletePathway();
      setAlert(!alert);
      NotificationManager.success("Pathway Deleted", 5000);
      ExecuteGetAllPathwaysUrl();
    } catch (exception) {
      setAlert(false);
      console.log("Error in Deleting Pathway", exception);
      apiErrorHandler(exception, history);
    }
  };

  useEffect(() => {
    ExecuteGetAllPathwaysUrl(currentPage);
  }, [currentPage]);

  useEffect(() => {
    if (pathwaysData && !error) {
      setData(
        pathwaysData.data.map((prop, key) => {
          return {
            id: prop.Id,
            inquiryType: prop.InquiryTypeName,
            pathwayName: prop.Name,
            actions: (
              // we've added some custom button actions
              <div className="actions-center">
                {userToken && jwtDecode(userToken).role === "CustomerAdmin" ? (
                  <>
                    <Button
                      action
                      tooltipText="View Pathway"
                      justIcon
                      round
                      simple
                      size="sm"
                      color="primary"
                      onClick={() =>
                        history.push(
                          `${window.location.pathname}/view/${prop.Id}`
                        )
                      }
                    >
                      <VisibilityOutlinedIcon />
                    </Button>
                    <Button
                      action
                      tooltipText="View Diagnostic Questions"
                      justIcon
                      round
                      simple
                      size="sm"
                      color="primary"
                      onClick={() => {
                        history.push(
                          `${window.location.pathname}/${prop.Id}/diagnostic-questions`
                        );
                      }}
                    >
                      <LiveHelpOutlinedIcon />
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      action
                      tooltipText="View Pathway"
                      justIcon
                      round
                      simple
                      size="sm"
                      color="primary"
                      onClick={() =>
                        history.push(
                          `${window.location.pathname}/view/${prop.Id}`
                        )
                      }
                    >
                      <VisibilityOutlinedIcon />
                    </Button>

                    <Button
                      action
                      tooltipText="Edit Pathway"
                      justIcon
                      round
                      simple
                      size="sm"
                      color="primary"
                      onClick={() =>
                        history.push(
                          `${window.location.pathname}/edit/${prop.Id}`
                        )
                      }
                    >
                      <CreateOutlinedIcon />
                    </Button>
                    <Button
                      action
                      tooltipText="Delete Pathway"
                      justIcon
                      round
                      simple
                      size="sm"
                      color="primary"
                      onClick={() => toggleDelete(prop.Id)}
                    >
                      <DeleteForeverOutlinedIcon />
                    </Button>
                    <Button
                      action
                      tooltipText="Manage Diagnostic Questions"
                      justIcon
                      round
                      simple
                      size="sm"
                      color="primary"
                      onClick={() => {
                        history.push(
                          `${window.location.pathname}/${prop.Id}/diagnostic-questions`
                        );
                      }}
                    >
                      <LiveHelpOutlinedIcon />
                    </Button>
                  </>
                )}
              </div>
            ),
          };
        })
      );
    }
  }, [pathwaysData]);

  const toggleDelete = (id) => {
    setPathwayId(id);
    setAlert(!alert);
  };

  const classes = useStyles();

  const columns = [
    {
      Header: "Inquiry Type",
      accessor: "inquiryType",
      alignment: "center",
    },
    {
      Header: "Pathway Name",
      accessor: "pathwayName",
      alignment: "center",
    },

    {
      Header: (
        <div
          style={{
            textAlign: "center",
          }}
        >
          Actions
        </div>
      ),
      accessor: "actions",
      alignment: "center",
    },
  ];

  if (loading) {
    return <Loading loading />;
  }
  if (deleteLoading) {
    return <Loading deleteLoading />;
  }
  if (error) {
    apiErrorHandler(error, history);
  }

  if (error) {
    apiErrorHandler(error, history);
  }

  return (
    <GridContainer className={classes.center}>
      <AlertModal
        alert={alert}
        setAlert={setAlert}
        onDelete={() => deletePathwayhandler()}
        onCancel={() => setAlert(!alert)}
      />
      <GridItem xs={12}>
        <Card>
          <CardHeader>
            <TableHeader
              title={
                userToken && jwtDecode(userToken).role === "CustomerAdmin"
                  ? "View Pathways"
                  : "Manage Pathways"
              }
              // subTitle="ERP Operational Readiness"
              btnText={
                userToken && jwtDecode(userToken).role === "CustomerAdmin"
                  ? null
                  : "Create Pathway"
              }
              goBackRoute={
                userToken && jwtDecode(userToken).role === "CustomerAdmin"
                  ? "/customerAdmin/inquiry-type-management"
                  : "/superAdmin/inquiry-type-management"
              }
              showBackButton
              onClick={() => history.push(`${window.location.pathname}/create`)}
            />
          </CardHeader>
          <CardBody>
            <ReactTable
              columns={columns}
              data={data}
              loading={loading}
              currentPage={pathwaysData && pathwaysData.currentPage}
              defaultPageSize={pathwaysData && pathwaysData.pageSize}
              totalItems={pathwaysData && pathwaysData.totalItem}
              totalPages={pathwaysData && pathwaysData.totalPage}
              setCurrentPage={setCurrentPage}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default definePathways;
